const userName = (state) => state.user && state.user.name.givenName
const userId = (state) => state.user && state.user._id
const hasTeacherAccess = (state) => state.hasTeacherAccess

export default {
  userId,
  userName,
  hasTeacherAccess,
}
